// reusable selectors for auth Slices
import { useSelector } from "react-redux";
import { IExpertSchedule } from "redux/reducers/expertScheduleSlice";
import { RootSliceType } from "redux/reducers/rootReducer";

const useEpertScheduleSelectors = () => {
  const expertSchedule = useSelector<
    RootSliceType,
    IExpertSchedule["schedules"]
  >((state) => state.expertSchedule.schedules);

  const expertTemplate = useSelector<
    RootSliceType,
    IExpertSchedule["template"]
  >((state) => state.expertSchedule.template);

  const selectedSlot = useSelector<
  RootSliceType,
  IExpertSchedule["selectedSlot"]
>((state) => state.expertSchedule.selectedSlot);

  return {
    expertSchedule,
    expertTemplate,
    selectedSlot
  };
};

export default useEpertScheduleSelectors;
